<div class="main-container">
	<h3>Your accounts</h3>

	<div class="search-container main-form">
		<form [formGroup]="searchFormGroup">
			<mat-form-field>
				<mat-label>Search</mat-label>
				<input matInput formControlName="query" />
			</mat-form-field>
		</form>
	</div>

	<button type="button" mat-flat-button class="main-tile" *ngFor="let account of visibleUserAccounts" (click)="tryRedirect(account)">
		{{ account.accountName }}
	</button>
</div>